import { HTTP_CP_LoadSignUpBranding_Response } from '@api-new/companyservice';
import { createSelector } from '@ngrx/store';
import { DEFAULT_LOGO_URL } from '@shared/contants';
import { selectSignUpState } from '@shared/store/sign-up/sign-up.selectors';

export const selectSignUpBrandingState = createSelector(selectSignUpState, (state) => state.branding);

export const selectSignUpBranding = createSelector(
  selectSignUpBrandingState,
  (brandingState): HTTP_CP_LoadSignUpBranding_Response | null => brandingState.entity,
);

export const selectSignUpBrandingLogoUrl = createSelector(
  selectSignUpBranding,
  (branding): string => branding?.logoUrl ?? DEFAULT_LOGO_URL,
);

export const selectSignUpBrandingCompanyId = createSelector(
  selectSignUpBranding,
  (branding): string | null => branding?.signUpCompanyId ?? null,
);

export const selectSignUpBrandingIsLoading = createSelector(selectSignUpBrandingState, (brandingState): boolean => brandingState.loading);

export const selectSignUpBrandingReferralCode = createSelector(
  selectSignUpBrandingState,
  (brandingState): string | null => brandingState.referralCode,
);
